import type { IconProps } from "./types";

export function CircleCheck({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
      ? color
      : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 1.7998C5.47126 1.7998 1.7998 5.47126 1.7998 10C1.7998 14.5287 5.47126 18.2002 10 18.2002C14.5287 18.2002 18.2002 14.5287 18.2002 10C18.2002 5.47126 14.5287 1.7998 10 1.7998ZM13.3369 6.3916C13.6728 6.02552 14.2421 6.00114 14.6084 6.33691C14.9745 6.67282 14.9988 7.2421 14.6631 7.6084L9.16309 13.6084C8.99265 13.7942 8.75212 13.9004 8.5 13.9004C8.24788 13.9004 8.00736 13.7942 7.83691 13.6084L5.33691 10.8809C5.00109 10.5145 5.02536 9.94527 5.3916 9.60938C5.75801 9.27353 6.32722 9.29864 6.66309 9.66504L8.49902 11.668L13.3369 6.3916Z"
        fill={currentColor}
        transform="translate(2 2)"
      />
    </svg>
  );
}
